const urlName = '/usercenter/v2/t-c/saas'
export default (API) => ({
	findMySaas() {
		return API({
			url: `${urlName}/findMySaas`,
			method: 'post',
		})
	},
})
